import { Sparkles, Clock, Loader2, XCircle, CheckCircle2, CircleStop } from "lucide-react";
import { AppColorVariant } from "../../theme/AppColorVariant";

export enum JobRequestStatus {
  Pending = "pending",
  Processing = "processing",
  Failed = "failed",
  Completed = "completed",
  /** Someone stopped the job before it finished. It is never run again. */
  Stopped = "stopped",
  New = "new",
}

export const JobRequestStatusLabels: Record<JobRequestStatus, string> = {
  [JobRequestStatus.Pending]: "Pending",
  [JobRequestStatus.Processing]: "Processing",
  [JobRequestStatus.Failed]: "Failed",
  [JobRequestStatus.Completed]: "Completed",
  [JobRequestStatus.Stopped]: "Stopped",
  [JobRequestStatus.New]: "New",
};

export const JobRequestStatusColors: Record<
  JobRequestStatus,
  AppColorVariant
> = {
  [JobRequestStatus.Pending]: "neutral",
  [JobRequestStatus.Processing]: "primary",
  [JobRequestStatus.Failed]: "danger",
  [JobRequestStatus.Completed]: "success",
  [JobRequestStatus.Stopped]: "warning",
  [JobRequestStatus.New]: "lime",
};

export const JobRequestStatusIcons: Record<JobRequestStatus, React.ElementType> = {
  [JobRequestStatus.New]: Sparkles,
  [JobRequestStatus.Pending]: Clock,
  [JobRequestStatus.Processing]: Loader2,
  [JobRequestStatus.Failed]: XCircle,
  [JobRequestStatus.Completed]: CheckCircle2,
  [JobRequestStatus.Stopped]: CircleStop,
};
